import { inferSectionMode } from 'pages/private/owner/Workouts/forms/workoutBuilder/inferSectionMode';
import { WorkoutTemplatePreviewData } from 'pages/private/owner/Workouts/Library/components/WorkoutLibrary/WorkoutTemplates/components/ModalWorkoutTemplatePreview';
import { WorkoutRetrieve } from 'types';
import { ScoreTypeEnum } from 'types/enums';

export function buildPreviewData(workout: WorkoutRetrieve): WorkoutTemplatePreviewData {
  return {
    workoutTemplateId: workout.workoutId,
    name: workout.name,
    athleteNotes: workout.athleteNotes,
    coachNotes: workout.coachNotes,
    sections: [...workout.sections]
      .sort((a, b) => a.orderIndex - b.orderIndex)
      .map(section => ({
        name: section.name,
        workoutInstructions: section.workoutInstructions,
        scoreEntireSection: inferSectionMode(section) === 'section_level',
        movements: (section.movements || [])
          .slice()
          .sort((a, b) => a.orderIndex - b.orderIndex)
          .map(movement => ({
            workoutMovement: {
              workoutMovementId: movement.workoutMovement?.workoutMovementId,
              name: movement.workoutMovement?.name || 'Unknown Movement',
              movementType: movement.workoutMovement?.movementType,
            },
            scoreType: movement.scoreType as ScoreTypeEnum,
          })),
      })),
  };
}
